var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm.showPassword ? _c('div', {
    staticClass: "input-group-hide-pass"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    key: "password",
    staticClass: "input-hide-pass",
    class: {
      'error': _vm.hasError.message
    },
    attrs: {
      "type": "text",
      "placeholder": "Пароль"
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value;
      }
    }
  }), _c('button', {
    staticClass: "eye-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleShow
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/eye-open.svg"),
      "alt": "show"
    }
  })])]) : _c('div', {
    staticClass: "input-group-hide-pass"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    key: "password",
    staticClass: "input-hide-pass",
    class: {
      'error': _vm.hasError
    },
    attrs: {
      "type": "password",
      "placeholder": "Пароль"
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value;
      }
    }
  }), _c('button', {
    staticClass: "eye-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleShow
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/eye-close.svg"),
      "alt": "hide"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }